
<template>
  <v-form ref="form" v-model="valid" lazy-validation>
    <v-container>
      <h4>Süt Tipi Ekle</h4>
      <v-row style="margin-top:100px;">
        <v-col cols="12" md="4">
          <h4>Başlık</h4>
          <v-text-field v-model="milkTypeData.milkType" :rules="titleRules" required></v-text-field>
        </v-col>
        <v-col cols="12" md="8"></v-col>

        <v-col cols="12" md="4">
          <h4>Aktif/Pasif</h4>
          <v-checkbox v-model="milkTypeData.active"></v-checkbox>
        </v-col>
        <v-col cols="12" md="8"></v-col>

        <v-col cols="12" md="7">
          <v-btn
            depressed
            color="primary"
            style="text-transform: none !important;float:right;"
            @click="milkTypeAdd()"
          >EKLE</v-btn>
        </v-col>
      </v-row>

      <!-- <v-row>
          
      </v-row>-->
    </v-container>
  </v-form>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "MilkType",
  methods: {
    ...mapActions(["addMilkType"]),
    routeMilkTypes() {
      this.$router.push("/dashboard/productCategories/milkTypes");
    },
    milkTypeAdd() {
      if (this.$refs.form.validate()) {
        this.snackbar = true;
        this.addMilkType(this.milkTypeData).then(response=>{
          console.log(response);
          if(response.processStatus == "Success") {
            this.routeMilkTypes();
          }
        });
      }
    }
  },
  data: () => ({
    dialog: false,
    valid: true,
    titleRules: [v => !!v || "Başlık alanı zorunludur."],
    milkTypeData:{
        milkType:"",
        active:true
    }

  })
};
</script>
